import {TranslationObject} from '@colonist/i18n'
import {socket} from '../../EntryShared'
import {UIRoomWarningPopupContentBase} from './UIRoomWarningPopupContentBase'

export class ReadyUpExceedLimitWarningContent extends UIRoomWarningPopupContentBase {
    shouldShowWarning(): boolean {
        const userSession = this.roomState.getSessions().find((session) => session.userSessionId == socket.controller.session.id)
        if(this.roomState.hostSession.userSessionId == socket.controller.session.id) return false
        if(userSession?.isReadyToPlay) return false
        return this.roomState.gameSetting.victoryPointsToWin > this.roomState.victoryPointsRecommendedLimit
    }

    // eslint-disable-next-line class-methods-use-this
    getTitle(): TranslationObject {
        return {key: 'strings:roomPage.warnings.readyUpExceedLimitWarning.title'}
    }

    // eslint-disable-next-line class-methods-use-this
    getDescription(): TranslationObject {
        return {key: 'strings:roomPage.warnings.readyUpExceedLimitWarning.description'}
    }
}
